import React from "react";
import { fmtEuro, fmtDate, RUN_TYPE_LABEL } from "@/lib/format";
import { Dialog, DialogContent } from "@/components/ui/dialog";

export default function PayslipModal({ item, run, onClose }) {
  const rows = [
    ["Μηνιαίες αποδοχές", fmtEuro(item.monthly_base)],
    ["% εργασίας", `${Math.round((item.work_pct || 0) * 100)}%`],
    ["Υπερωρίες", fmtEuro(item.overtime_amount)],
    ["Ώρες υπερωριών", item.overtime_hours || 0],
    ["ΦΜΥ (Παρακράτηση φόρου)", fmtEuro(item.tax || 0)],
    ["Κατάθεση τράπεζα", fmtEuro(item.bank_deposit)],
  ];
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md p-0 overflow-hidden">
        <div className="bg-white">
          <div className="bg-[#45423C] text-white px-6 py-5 flex items-center gap-3">
            <div>
              <div className="text-[10px] uppercase tracking-[0.25em] text-white/70">Σημείωμα πληρωμής</div>
            </div>
          </div>
          <div className="px-6 py-5">
            <div className="flex items-center justify-between">
              <div>
                <div className="text-[10px] uppercase tracking-wider text-[#6F6A60]">Υπάλληλος</div>
                <div className="font-serif text-xl text-[#45423C]">{item.name}</div>
                <div className="text-xs text-[#6F6A60] mt-0.5">
                  Τμήμα: {item.department || "—"} · Ρόλος: {item.position || "—"}
                </div>
              </div>
              <div className="text-right">
                <div className="text-[10px] uppercase tracking-wider text-[#6F6A60]">Περίοδος</div>
                <div className="text-sm font-medium">{run.label_el || RUN_TYPE_LABEL[run.run_type]}</div>
                <div className="text-xs text-[#6F6A60]">{fmtDate(run.period_end)}</div>
              </div>
            </div>

            <div className="mt-5 space-y-2">
              {rows.map(([k, v]) => (
                <div key={k} className="flex items-center justify-between text-sm py-1.5 border-b border-dashed border-[#E3DED4]">
                  <span className="text-[#6F6A60]">{k}</span>
                  <span className="tabular font-medium text-[#45423C]">{v}</span>
                </div>
              ))}
            </div>

            <div className="mt-4 rounded-xl bg-[#EEF0EA] px-4 py-3 flex items-center justify-between">
              <span className="text-sm font-semibold text-[#6E7A63]">Συνολικές αποδοχές</span>
              <span className="font-serif text-xl text-[#6E7A63] tabular">{fmtEuro(item.total_earnings)}</span>
            </div>
            <div className="mt-2 rounded-xl bg-[#45423C] px-4 py-3 flex items-center justify-between text-white">
              <span className="text-sm font-semibold">Υπόλοιπο αποδοχών</span>
              <span className="font-serif text-xl tabular">{fmtEuro(item.remaining)}</span>
            </div>
            {item.tips ? (
              <div data-testid="payslip-tips-line" className="mt-2 rounded-xl border border-[#E3DED4] px-4 py-3 flex items-center justify-between">
                <span className="text-sm font-semibold text-[#45423C]">Tips (ξεχωριστά)</span>
                <span className="font-serif text-lg text-[#45423C] tabular">{fmtEuro(item.tips)}</span>
              </div>
            ) : null}
            {item.comments ? <div className="mt-3 text-xs text-[#6F6A60]">Σημείωση: {item.comments}</div> : null}
            <div className="mt-4 text-[10px] text-[#6F6A60]">Ποσά σε Ευρώ (€).</div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
